import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonLib, JsonService } from 'src/common/dw_service';
import { DWNavigationService } from 'src/common/dw_navigation_service';
import { environment } from 'src/environments/environment';

declare var window: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'campaign-form';

  constructor(
    private CL: CommonLib,
    private router: Router,
    private jsonservice: JsonService,
    private nav: DWNavigationService,
    private http: HttpClient
  ) {
    // 本番時、console.logを空関数に上書き
    if(environment.production) {
      if (window) {
        window.console.log = () => {};
        window.console.info = () => {};
      }
    }

    console.log("AppComponent.ts")
    
    // バージョンチェック（強制更新）
    this.checkVersion();
    let pageUrl: string = "/";
    // urlクエリ（# より前だけ。jt に = が含まれ #/ 以降が混ざるのを防ぐ）
    let query = window.location.href.split('?')[1];
    if (query && query.indexOf('#') >= 0) {
      query = query.split('#')[0];
    }
    pageUrl = this.CL.getNextPage(query);
    this.CL.setAkatsukiUrlQuery(query);

    this.getConfigJson();

    if(!environment.production) {
      // test
      // coupon
      // this.CL.itemType = "27";
      // this.CL.eventKey = "7636F4F8AC1A321C6F25E010D7F4A855EAD7AEAFA67CAFD33D5470A50127B4A2";
      // this.CL.eventId = 2064;
      // this.CL.tenantId = 37;
      // pageUrl = "/coupon-detail";
      // no barcode
      // this.CL.itemType = "27";
      // this.CL.eventKey = "073D53BACB8F1D3BC14FFCDCC08D92274B767112CFE6A65B1109FA2A965936ED";
      // this.CL.eventId = 2078;
      // this.CL.tenantId = 37;
      // pageUrl = "/coupon-detail";
      // form
      // this.CL.eventKey = "8DAEA85F35A1DE82B18E99BD7B8655EE25808386D4A591439BC8B5CB891CEE11";
      // this.CL.itemType = "41"; 
      // this.CL.tenantId = 37;
      // pageUrl = "/form-input";
    }

    this.nav.push(pageUrl);

  }



  /**
   * バージョンチェック（強制更新）
   * サーバーのバージョンとローカルストレージのバージョンを比較し、
   * 異なる場合はキャッシュをクリアしてリロード
   */
  private checkVersion(): void {
    // キャッシュを回避するためにタイムスタンプを追加
    const url = `assets/version.txt?t=${Date.now()}`;
    
    this.http.get(url, { responseType: 'text' }).subscribe({
      next: (serverVersion) => {
        const currentVersion = serverVersion.trim();
        const cachedVersion = localStorage.getItem('app_version');
        
        if (cachedVersion && cachedVersion !== currentVersion) {
          // バージョンが異なる場合、キャッシュをクリアしてリロード
          console.log(`バージョン更新: ${cachedVersion} → ${currentVersion}`);
          localStorage.setItem('app_version', currentVersion);
          
          // キャッシュをクリアしてリロード
          if ('caches' in window) {
            caches.keys().then((names) => {
              names.forEach((name) => caches.delete(name));
            });
          }
          window.location.reload();
        } else if (!cachedVersion) {
          // 初回アクセス時はバージョンを保存
          localStorage.setItem('app_version', currentVersion);
        }
      },
      error: (error) => {
        console.error('バージョンチェックに失敗:', error);
      }
    });
  }

  // config.json取得
  private getConfigJson() {
    const o = this;
    o.jsonservice.execGetJson("assets/conf/config.json").subscribe({
      next: (res: any) => {
        o.CL.setConfigJson(res);
        const os = "Browser";
        try {
          let e = document.getElementById("base_floating_env_dialog");
          if(e) {
            if (res.env == "stg" || res.env == "dev") {
              e.innerText = res.env;
              e.style.display = "block";
            } else {
              e.style.display = "none";
            }
          }
        } catch (ex) {}
        // if (res.force_update && res.force_update[os]) {
        //   const osData = res.force_update[os];
        //   const verCode = environment.base.appVersion;
        //   for (const key in osData.target) {
        //     let forceFlg = true;
        //     if (osData.target[key].condition) {
        //       if (osData.target[key].condition === 'lessthan') {
        //         if (osData.target[key].ver) {
        //           if (osData.target[key].ver === verCode) {
        //             forceFlg = false;
        //           }
        //           else {
        //             const ver1 = osData.target[key].ver.split('.');
        //             const ver2 = verCode.split('.');
        //             if (Number(ver1[0]) < Number(ver2[0])) {
        //               forceFlg = false;
        //             }
        //             else if (Number(ver1[0]) === Number(ver2[0])) {
        //               if (Number(ver1[1]) < Number(ver2[1])) {
        //                 forceFlg = false;
        //               }
        //               else if (Number(ver1[1]) === Number(ver2[1])) {
        //                 if (Number(ver1[2]) <= Number(ver2[2])) {
        //                   forceFlg = false;
        //                 }
        //               }
        //             }
        //           }
        //         }
        //       }
        //     }
        //     // 強制アップデートの実行
        //     if (forceFlg) {
        //       setTimeout(() => {
        //         window.location.reload();
        //       }, 100)
        //       return;
        //     }
        //     break;
        //   }
        // }
      },
      error: (err: any) => {

      }
    })
  }
}
